<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Helpful Hints"><div class="titlepage"><div><div><h1 class="title"><a id="d0e28" xmlns:saxon="http://icl.com/saxon">Helpful Hints </a></h1></div></div></div><p><a id="d0e28" xmlns:saxon="http://icl.com/saxon">1. Small boxes of sugar-free instant pudding can be used in place of the small boxes of
        regular instant pudding in most recipes. Low-fat or non-fat ingredients can be used in most
        recipes as well. </a></p><p><a id="d0e28" xmlns:saxon="http://icl.com/saxon">2. Vanilla, white chocolate, or cheesecake pudding mixes can be used interchangeably in
        most recipes. </a></p><p><a id="d0e28" xmlns:saxon="http://icl.com/saxon">3. Store recipe leftovers in the refrigerator. Most of the recipes in this book contain
        milk-based products and should be stored at a cold temperature before and after being
        served. </a></p><p><a id="d0e28" xmlns:saxon="http://icl.com/saxon">4. For best results, thaw frozen whipped topping in the refrigerator a day before you plan
        to use it. </a></p><p><a id="d0e28" xmlns:saxon="http://icl.com/saxon">5. For cakes, always grease and flour the cake pan, or spray it with nonstick cooking
        spray even when the cake recipe doesn’t call for it. </a></p><p><a id="d0e28" xmlns:saxon="http://icl.com/saxon">6. Bake cakes and cookies on the middle oven rack, never on the top or bottom racks. To
        see if a cake is done, insert a toothpick into the center—if it comes out clean
        it’s done. Or, if the cake springs back when touched, it’s usually done. </a></p><p><a id="d0e28" xmlns:saxon="http://icl.com/saxon">7. For best results, use glass or stoneware baking dishes. </a></p><p><a id="d0e28" xmlns:saxon="http://icl.com/saxon">8. The first time you try a recipe, check for doneness 5 minutes before its minimum
        cooking time ends. Every oven heats differently. </a></p><p><a id="d0e28" xmlns:saxon="http://icl.com/saxon">9. For chewier and softer cookies and bars, take them out of the oven just as they begin
        to look golden and let them cool on or in the pan. </a></p><p><a id="d0e28" xmlns:saxon="http://icl.com/saxon">10. For recipes using gelatin, make sure the gelatin is completely dissolved in hot water
        before adding any cold water. </a></p><p><a id="d0e28" xmlns:saxon="http://icl.com/saxon">11. When using fresh fruit, dip it in pineapple, orange, or lemon juice to prevent it from
        changing color.</a></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01.vue?3f4add19